module.exports = __webpack_public_path__ + "static/media/  (99).86f5dbaa.jpg";